"use client";
import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import CookieConsent from "react-cookie-consent";


export const PageLayout = ({ children }: any) => {
    return (
        <>
            <Navbar />
            {children}
            <CookieConsent
                overlay={true}
                location="bottom"
                buttonText="Sunt de acord!"
                cookieName="myAwesomeCookieName2"
                style={{
                    background: "#C6FF00",
                    color: "#000",
                    lineHeight: ".5rem",
                }}
                buttonStyle={{
                    background: "#00B8D4",
                    color: "#fff",
                    fontSize: "13px",
                    borderRadius: 5,
                    padding: "10px",
                }}
            >
                <span className="text-sm my-10">
                    <strong>Acest website foloseste cookie-uri</strong> pentru
                    analiza datelor vizitatorilor noștri si pentru a îmbunătăți
                    site-ul nostru.
                </span>
            </CookieConsent>
            <Footer />
        </>
    );
};
